import {Component} from '@angular/core';
import { CdsidComponent } from './user-cdsid/cdsid.component';
import { UserLocationComponent } from './user-warehouse/user-location.component';

@Component({
    selector: 'user-config',
    templateUrl: './user-config.component.html',
    styleUrls: ['./user-config.component.css'],
    imports: [CdsidComponent, UserLocationComponent]
})
export class UserConfigComponent {

}

